import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./app-mobile.css";
import "./initSignSuiteAuth";
import App from "./App";
import { syncUserIdFromQuery } from "./suiteSession";

syncUserIdFromQuery();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
